import { MessageSquare, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateLanguageDetectionOnTicketsWithAiAr: TemplateAr = {
  name: 'أتمتة كشف اللغة في التذاكر بالذكاء الاصطناعي',
  description:
    'اكشف لغة كل رسالة واردة تلقائياً، ووجّه ورُد وترجم على أساسها — بدون فرز يدوي.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'رسالة واردة' },
    { icon: Sparkles, label: 'كشف ذكي' },
    { icon: Users, label: 'ناطق أصلي', final: true },
  ],
  detailDescription: {
    paragraph1:
      'ادعم عملاءك بلغتهم، بدون صداع الفرز. الـ AI يكشف لغة كل تذكرة ورسالة دردشة وإيميل يجيك، ويوسم المحادثة، ويوجّهها لموظف يتكلم نفس اللغة، أو يرد هو مباشرة بلغة العميل. يشتغل مع +١٠٠ لغة، واللهجات معها (البرتغالية البرازيلية مقابل الأوروبية، والإسبانية اللاتينية مقابل الأوروبية، والصينية المبسطة مقابل التقليدية).',
    paragraph2:
      'ولمّا ما يكون فيه ناطق أصلي متفرّغ، الـ AI يرد بلغة العميل من قاعدة المعرفة عندك، ويوصّل نسخة لفريقك بلغته عشان يتابع. والمنصة تقيس جودة الترجمة لكل زوج لغات ولكل نوع طلب، فتعرف وين يتفوّق الـ AI ووين لازم يتدخّل البشر. وCSAT وFRT ومعدل الحل تشوفها لكل لغة على حدة.',
  },
  benefits: [
    'الـ AI يكشف اللغة ويوسمها في كل محادثة',
    'كل محادثة توصل لناطق أصلي أول ما يكون متفرّغ',
    'ما في موظف متفرّغ؟ الـ AI يرد بلغة العميل',
    'يشتغل بـ+١٠٠ لغة، ويعرف اللهجات',
    'شوف CSAT وFRT ومعدل الحل لكل لغة على حدة',
    'تعرف جودة الترجمة لكل نوع طلب',
  ],
};
